import { InputEmail } from "@/components/Input/Email/InputEmail";
import { HStack, VStack } from "@/components/Layout";
import { Label } from "@/components/ui/label";
import { defaultNS, useTranslation } from "@/lib/i18n";
import type { FormContextErrors } from "./-xstate/add-person-to-send-invitation-dialog.machine";

const AddPersonToSendInvitationDialogEmailFormItem = ({
  email,
  setEmail,
  errors,
  isOptional,
}: {
  email: string;
  setEmail: (value: string) => void;
  errors: FormContextErrors;
  isOptional?: boolean;
}) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix:
      "pages.settings.persons.account.tabFilterBar.addPersonToSendInvitationDialog",
  });

  return (
    <VStack className="gap-1.5">
      <HStack className="gap-2 items-center h-4">
        <Label className="text-xs font-semibold text-neutral-muted-on-fill">
          {t("email")}
        </Label>
        {isOptional && (
          <Label className="text-xs text-neutral-muted-on-fill">
            {t("optionalLabel")}
          </Label>
        )}
      </HStack>

      <InputEmail
        value={email}
        onChange={(value) => setEmail(value)}
        width="100%"
        errorMessage={errors.email && t(`validationErrors.${errors.email}`)}
      />
    </VStack>
  );
};

export default AddPersonToSendInvitationDialogEmailFormItem;
